import { apiClient } from '@/apis';
import axios from 'axios';
import { staticUrl } from '@/config';

export const getMeta = (url) => new Promise((resolve, reject) => {
  const image = new Image();
  image.onload = () => resolve(image);
  image.onerror = (err) => reject(err);

  axios.get(url, { responseType: 'blob' })
    .then((res) => {
      image.src = URL.createObjectURL(res.data);
    });
});

const map = {
  textmessage: 'textmessage',
  friendtalk: 'kakao/friendtalk',
  brand: 'kakao/brandtalk',
};

const staticMap = {
  textmessage: 'textmessage',
  friendtalk: 'kakaofriendtalk',
  brand: 'kakaobrandtalk',
};

export const getImageInfo = async ({ id, imageType }) => {
  if (!id) {
    return {};
  }

  const promiseList = [];

  promiseList.push(apiClient.get(`/${map[imageType]}/image/${id}`));
  promiseList.push(getMeta(`${staticUrl}/${staticMap[imageType]}/${id}`));

  const [
    {
      name,
      type,
    },
    {
      width,
      height,
    },
  ] = await Promise.all(promiseList);

  return {
    name,
    type,
    width,
    height,
  };
};
